import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(8),
    height: "100%",
  },
  backgrounplans: {
    zIndex: -1,
    position: "absolute",
    top: "60px",
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(41, 67, 116, 0.7), rgba(41, 67, 116, 0.7)), url('/images/us/backgroundUs.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    width: "100%",
    height: "calc(100% - 60px)",
    minHeight: 550,
    [theme.breakpoints.up("sm")]: {
      height: "calc(100% - 220px)",
      minHeight: 650,
      //maxHeight: 1300,
    },
  },
  paperContent: {
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(10),
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(30),
    },
  },
  containertittle: {
    height: "100%",
  },
  gridtittle: {
    paddingBottom: theme.spacing(10),
    paddingTop: theme.spacing(10),
    //height: 'calc(100% - 100px)',
    minHeight: 550,
    [theme.breakpoints.up("sm")]: {
      //height: 'calc(100% - 400px)',
      minHeight: 400,
      paddingBottom: theme.spacing(10),
      paddingTop: theme.spacing(15),
    },
    [theme.breakpoints.down(321)]: {
      //height: 'calc(100% - 400px)',
      minHeight: 400,
      paddingBottom: theme.spacing(6),
      paddingTop: theme.spacing(6),
    },
  },
  tittleservicepage: {
    fontWeight: "bold",
    color: "#33658A",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
  },
  tittleservicepagebold: {
    fontWeight: "bold",
    color: "#33658A",
    fontFamily: "Century-Gothic",
    marginTop: theme.spacing(5),
    //marginBottom: theme.spacing(1),
  },
  subtittleservicepage: {
    //fontWeight: 'bold',
    color: "#33658A",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
  },
  subtittleservicepagebold: {
    fontWeight: "bold",
    color: "#33658A",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
  },
  subtittleservicepageleft: {
    color: "#33658A",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
    "& > *": {
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(3),
      },
    },
  },
  gridpei: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  gridfeature: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      marginBottom: theme.spacing(4),
    },
  },
  titlefeature: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      marginLeft: theme.spacing(0),
      textAlign: "center",
    },
  },
  namefeature: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
  },
  iconfeature: {
    fontSize: 35,
    color: "white",
    marginRight: theme.spacing(2),
    verticalAlign: "top",
  },
  contentfeature: {
    color: "white",
    fontFamily: "Century-Gothic",
  },
  textpei: {
    //fontWeight: 'bold',
    color: "white",
    fontFamily: "Century-Gothic",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
      textAlign: "center",
    },
  },
  textlink: {
    fontWeight: "bold",
    color: "white",
    textDecoration: "none",
    fontFamily: "Century-Gothic",
    "&:hover": {
      color: "white",
      textDecoration: "none",
    },
  },
  avatarImage: {
    width: "90%",
    height: "80%",
    borderRadius: "10px",
    boxShadow: '0px 0px 10px black',
    pointerEvents: 'none'
  },
  avaluaImage:{
    borderRadius: "10px",
    boxShadow: '0px 0px 10px black',
    pointerEvents: 'none'
  },
  gridteam: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      textAlign: "center",
      align: "center",
    },
  },
  titleteam: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(4),
      textAlign: "center",
    },
  },
  subtitleteam: {
    //fontWeight: 'bold',
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  subtitleteamgrid: {
    //fontWeight: 'bold',
    color: "white",
    fontFamily: "Century-Gothic",
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(6),
      textAlign: "center",
    },
  },
  subtitleteambold: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
  },
  teamember: {
    width: theme.spacing(18),
    height: theme.spacing(18),
    marginRight: theme.spacing(2),
    pointerEvents: 'none',
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(2),
    },
    "& > *": {
      objectPosition: "top",
    },
  },
  textteam: {
    fontWeight: "bold",
    color: "white",
    fontFamily: "Century-Gothic",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
    }, 
    // "& > *": {
    //   color: "white",
    //   fontFamily: "Century-Gothic",
    //   [theme.breakpoints.down(1020)]: {
    //     fontSize: "smaller",
    //   },
    // },
  },
  contentteam: {
    color: "white",
    fontFamily: "Century-Gothic",
    [theme.breakpoints.down("xs")]: {
      textAlign: "center",
    },
  },
  socialteam: {
    color: "white",
    marginTop: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      "& > * + *": {
        marginLeft: theme.spacing(3),
      },
    },
    [theme.breakpoints.down("xs")]: {
      justifyContent: "space-evenly",
    },
  },
  iconsocial: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: "white",
  },

  ContainerServiceOne: {
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(35, 37, 41, 0.75), rgba(35, 37, 41, 0.75)), url('/images/us/values.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  ContainerServiceTwo: {
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(35, 37, 41, 0.6), rgba(35, 37, 41, 0.6)), url('/images/us/backgroundPei.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  ContainerServiceTree: {
    backgroundSize: "cover",
    backgroundImage: "linear-gradient(rgba(35, 37, 41, 0.7), rgba(35, 37, 41, 0.7)), url('/images/us/teamCompute.jpg')",  
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
}));

export default useStyles;
